import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { CREATE_COMMUNITY_ROLE_RESOURCE, COMMUNITY_ROLES_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_COMMUNITY_ROLE_RESOURCE,
      method: 'post',
      request: (communityId, organisationRoleTag, body, callback, t) => ({
        body,
        url: apiRoutes.communityRoles2(communityId, organisationRoleTag),
        meta: {
          callback,
          addToOtherList: {
            resource: COMMUNITY_ROLES_RESOURCE,
            listPath: 'communityRoles',
            idProp: 'tag',
            id: organisationRoleTag,
            valuesModifier: values => ({ ...body, ...values }),
          },
          toaster: {
            onSuccessMessage: t('addCommunityRoleSuccess'),
            onErrorMessage: createErrorMessage(t, 'addCommunityRoleFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);
